module.exports = __webpack_public_path__ + "img/terminal.f3756d21.png";